import { CONTENTFUL_MOBILE_PRESENTATION_TYPES } from 'data-layer/constants';
import type { ContentfulMobilePresentationType } from 'data-layer/types';

/**
 * Determines if a given layout is swipeable.
 *
 * @param layout - The layout to check, which can be a string or a value from CONTENTFUL_MOBILE_PRESENTATION_TYPES.
 * @returns A boolean indicating whether the layout is swipeable.
 */
export function isSwipeable(layout: ContentfulMobilePresentationType | string) {
  return layout === '' || layout === CONTENTFUL_MOBILE_PRESENTATION_TYPES.SWIPEABLE;
}
